import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import CardRejected from '@perpay-web/fintech/components/composite/CardRejected/CardRejected';
import CardStandardRejection from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedCreditKarma/CardStandardRejection';
import NonCreditKarmaPartnerHostedOnboardingRejected from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedNonCreditKarma/NonCreditKarmaPartnerHostedOnboardingRejected';

type CardRejectionSwitcherProps = {
    isLoading: boolean;
    passedKyc: boolean;
    isPHO: boolean;
    isCreditKarmaPartner: boolean;
    marketplaceSpendingLimit: number | null;
    onMount: VoidFunction;
    onClickDashboard: VoidFunction;
    onClickShop: VoidFunction;
};

const CardRejectionSwitcher = ({
    isLoading,
    passedKyc,
    isPHO,
    isCreditKarmaPartner,
    marketplaceSpendingLimit,
    onMount,
    onClickDashboard,
    onClickShop,
}: CardRejectionSwitcherProps) => {
    const hasASpendingLimit = !!marketplaceSpendingLimit;

    if (isLoading) {
        return <WarningLoaderCircle />;
    }

    // Standard rejection: CK pho, failed KYC, or no spending limit
    if (!passedKyc || isCreditKarmaPartner || !hasASpendingLimit) {
        return (
            <CardStandardRejection
                onMount={onMount}
                onClickDashboard={onClickDashboard}
                isPho={isPHO}
            />
        );
    }

    // PHO with spending limit: Non-CK partner
    if (isPHO) {
        return (
            <NonCreditKarmaPartnerHostedOnboardingRejected
                isLoading={isLoading}
                onMount={onMount}
                spendingLimit={marketplaceSpendingLimit}
                onClickDashboard={onClickDashboard}
            />
        );
    }

    // Default: CardRejected (non-PHO, passed KYC, has spending limit)
    return (
        <CardRejected
            isLoading={isLoading}
            spendingLimit={marketplaceSpendingLimit}
            onMount={onMount}
            onClickShop={onClickShop}
            onClickDashboard={onClickDashboard}
        />
    );
};

export default CardRejectionSwitcher;
